import { Box, Grid, Typography } from "@material-ui/core";
import AboutMe from "./components/AboutMe";
import ExpCard from "../../components/ExpCard";
import ProjectCard from "../../components/ProjectCard";
import TopPage from "../../components/TopPage";
import { education, experience, myProjects } from "../../utils/constants";
import { useStyles } from "./HomePage.styles";
import ContactForm from "./components/ContactForm";
import ProjectDetails from "../../components/ProjectDetails";
import { useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";


type defaultImageType =     {
        id: number,
        isDefault: boolean,
        imgUrl: string,
      }

function HomePage({
  togglePopup,
  setPopupChild,
}: any) {

  const classes = useStyles();
  const location = useLocation();
  const myRef = useRef<any>();


  function getDefault(images: defaultImageType[]): defaultImageType | void {

    const findDefault = images.find(img => img.isDefault)

    return findDefault;
  }
  function handleSelectedProject(project: any){
    setPopupChild(<ProjectDetails project={project} />)
    togglePopup({isPopupOpen: true})
  }

    useEffect(() => {
    const element = myRef.current;

     element?.scrollIntoView({
        behavior: element ? 'smooth' : 'auto',
      });
  }, [location]);

  return (
    <Grid xs={12} className={classes.pageRoot}>
      <Grid xs={12}>
        <Grid>
          <TopPage />
        </Grid>
        <Grid ref={(location.state === 'ABOUT' || location.state === 'SKILL' ) ? myRef : null}>
          <AboutMe />
        </Grid>
        <Grid className={classes.section2}>
        <Grid ref={location.state === 'EXPERIENCE' ? myRef : null}>
          <Typography className={classes.experienceTitle}>Work Experience</Typography>
          <Box>
            {
              experience.map(item =>(
                <ExpCard
                title={item.title}
                institution={item.institution}
                startDate={item.startDate}
                endDate={item.endDate}
                description={item.description}
                onClick={() => {
                  if(item?.url){
                    window.open(item.url, '_blank');
                  }
                }}
                 />
              ))
            }
          </Box>
        </Grid>
        <Box>
          <Typography className={classes.EdTitle}>Education</Typography>
          <Box>
            {
              education.map(item =>(
                <ExpCard
                title={item.title}
                institution={item.institution}
                startDate={item.startDate}
                endDate={item.endDate}
                description={item.description}
                 />
              ))
            }
          </Box>
        </Box>
        <Grid ref={location.state === 'PORTFOLIO' ? myRef : null}>
          <Typography className={classes.projectSection}>Project</Typography>
          <Box className={classes.projectCardWrap}>
            {
              myProjects.map(item =>(
                <ProjectCard
                onClick={() => handleSelectedProject(item)}
                defaultImage={getDefault(item.images)?.imgUrl || ''}
                projectTitle={item.name}
                appType={item.appType}
                 />
              ))
            }
          </Box>
        </Grid>
        <Box>
          <ContactForm />
        </Box>
        </Grid>
      </Grid>
    </Grid>
  );
}
export default HomePage;
